"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('rinca.core.confirmDialog', [])
    .service('confirmDialog', ['$q', 'ngDialog', function ($q, ngDialog) {
        this.open = function (html) {
            var delay = $q.defer();
            var confirm_dialog = ngDialog.open({
                template: '\
		    <p class="title">Da li ste sigurni?</p>\
		    <p class="message">' + html + '</p>\
		    <div class="ngdialog-buttons">\
		        <button class="button bl-secondary" ng-click="no()">Ne</button>\
		        <button class="button bl-primary-bck" ng-click="yes()">Da</button>\
		    </div>',
                plain: true,
                appendClassName: 'confirm-modal',
                controller: ['$scope', function ($scope) {
                        $scope.yes = function () {
                            delay.resolve(true);
                            ngDialog.close(confirm_dialog.id);
                        };
                        $scope.no = function () {
                            ngDialog.close(confirm_dialog.id);
                            delay.reject(false);
                        };
                        confirm_dialog.closePromise.then(function (data) {
                            delay.reject(false);
                        });
                    }]
            });
            return delay.promise;
        };
    }]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/services/confirmDialog.js
// module id = 295
// module chunks = 0